import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Subject } from "rxjs/Rx";
import { DialogComponent } from "src/app/dialog/dialog.component";
import { InvoiceModel } from "../models/factor.model";
import { WebsocketService } from "./websocket.service";

const CHAT_URL = "ws://127.0.0.1:1372/";
//const CHAT_URL = "ws://192.168.247.65:1372/";

export class ParsianPaymentModel {
  CompanyName: string;
  RequestType: string;
  AM: string;
  paymentType: string;
  GovID: string;
  SC: string;
  ID: string;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = "Sale";
    this.AM = "0";
    this.paymentType = "CARD";
    this.ID = "";
    this.GovID = "";
    this.SC = "4020";
  }
}
export class ParsianPosInfoModel {
  CompanyName: string;
  RequestType: string;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = 'getMerchantInfo';
  }
}
export class ParsianHasPaperModel {
  CompanyName: string;
  RequestType: string;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = 'checkPaper';
  }
}
export class ParsianReceiptBitMapModel {
  CompanyName: string;
  RequestType: string;
  invoice: InvoiceModel;
  constructor() {
    this.CompanyName = "SEPIDZ";
    this.RequestType = 'receiptBitMap';
    this.invoice = null;
  }
}
export class ParsianResponseModel {
  compName: string;
  trxType: string;
  RS: any;
  CN: any;
  RN: any;
  SN: any;
  TN: any;
  DT: any;
  AM: any;
  PS: any;
  CP: any;
  GI: any;
  TO: any;
  BR: any;
  MI: any;
  TS: any;
  TF: any;
  ER: any;
  RC: any;
}
@Injectable()
export class ParsianPosService {
  public messages: Subject<any>;
  public factorPrin = '';
  constructor(private wsService: WebsocketService, private dialog: MatDialog, private spinner: NgxUiLoaderService) { }

    connect(){
      this.messages = <Subject<any>>this.wsService.connect(CHAT_URL).map(
        (response: MessageEvent): ParsianResponseModel => {
          let data: ParsianResponseModel = JSON.parse(response.data);
          let res: boolean = false;
          if (data.ER !== 'null') {
            const dialogRef = this.dialog.open(DialogComponent);
            dialogRef.componentInstance.title = 'توجه';
            dialogRef.componentInstance.hasCancel = true;
            dialogRef.componentInstance.message = `${data.ER}`;
            dialogRef.afterClosed().subscribe(result => {
              res = false;
              this.spinner.stopAll();
              return;

            });
          }
          else {
            if (data.RS !== 'null') {
              if (data.RS === '00') {
                const dialogRef = this.dialog.open(DialogComponent);
                dialogRef.componentInstance.title = 'توجه';
                dialogRef.componentInstance.hasCancel = true;
                dialogRef.componentInstance.message = `پرداخت با موفقیت انجام شد شماره پیگیری : ${data.SN}`;
                res = true;
                dialogRef.afterClosed().subscribe(result => {
                  res = true;
                  this.spinner.stopAll();

                });
              }
              else {
                const dialogRef = this.dialog.open(DialogComponent);
                dialogRef.componentInstance.title = 'توجه';
                dialogRef.componentInstance.hasCancel = true;
                dialogRef.componentInstance.message = `پرداخت با خطا روبرو شد `;
                dialogRef.afterClosed().subscribe(result => {
                  res = false;
                  this.spinner.stopAll();
                });
              }
            }
          }

          this.spinner.stopAll();
          return data;
        }
      );
    }
}
